export default {
  name: 'autocomplete',
  data () {
    return {
      open: false,
      current: 0,
      selectedSuggestion: null
    }
  },
  props: {
    suggestions: {
      type: Array,
      required: true
    },
    selectionId: {
      type: [Number, String],
      default: null
    },
    selectionText: {
      type: String,
      default: ''
    }
  },
  methods: {
    blur () {
      this.open = false
    },
    enter () {
      if (this.matches[this.current]) {
        this.selectedSuggestion = this.matches[this.current]
      }

      this.open = false
    },
    up () {
      if (this.current > 0) this.current--
    },
    esc () {
      if (this.open && this.current > 0) {
        this.selectedSuggestion = null
      }
      this.open = false
    },
    down () {
      if (this.current < this.matches.length - 1) this.current++
    },
    isActive (index) {
      return index === this.current
    },
    change (event) {
      if (!this.open) {
        this.open = true
        this.current = 0
      }
      this.$emit('update:selectionText', event.target.value)
    },
    inputClick () {
      if (this.matches.length > 0) {
        this.open = true
      }
    },
    suggestionClick (index) {
      this.selectedSuggestion = this.matches[index]
      this.open = false
    }
  },
  computed: {
    matches () {
      if (!this.selectionText && this.suggestions.length > 0) {
        return this.suggestions.slice(0, 5)
      }

      const searchText = this.selectionText.replace(/[^a-zA-Zа-яА-Я0-9]+/g, '').toLowerCase()

      return this.suggestions.filter(suggestion => {
        return suggestion.search.indexOf(searchText) >= 0
      }).slice(0, 5)
    },
    openSuggestion () {
      return this.suggestions && this.matches.length !== 0 && this.open
    }
  },
  watch: {
    selectionText: function (val) {
      if (this.selectedSuggestion && val !== this.selectedSuggestion.text) {
        this.$emit('update:selectionId', null)
      }
    },
    selectedSuggestion: function (val) {
      if (val) {
        this.$emit('update:selectionText', val.text)
        this.$emit('update:selectionId', val.value)
      } else {
        this.$emit('update:selectionId', null)
      }
    },
    selectionId: function (val) {
      const selectedSuggestion = this.suggestions.find(x => x.value === val)
      if (selectedSuggestion) {
        this.selectedSuggestion = selectedSuggestion
      } else {
        this.selectedSuggestion = null
      }
    }
  },
  created: function () {
    const selectedSuggestion = this.suggestions.find(x => x.value === this.selectionId)
    if (selectedSuggestion) {
      this.selectedSuggestion = selectedSuggestion
    }
  }
}
